import React, { CSSProperties } from 'react';
import { Table, TableProps } from 'antd';

/**
 * Custom Table wrapper with enhanced styling
 */
export interface MyTableProps<T = any> extends TableProps<T> {
  tableVariant?: 'default' | 'bordered' | 'striped' | 'compact';
  shadow?: boolean;
  rounded?: boolean;
}

function MyTable<T extends object = any>({
  tableVariant = 'default',
  shadow = true,
  rounded = true,
  style,
  className,
  ...rest
}: MyTableProps<T>) {
  const customStyle: CSSProperties = {
    boxShadow: shadow ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none',
    borderRadius: rounded ? '8px' : '0',
    overflow: 'hidden',
    ...style,
  };

  const tableClassName = [
    className,
    tableVariant === 'striped' ? 'striped-table' : '',
    tableVariant === 'compact' ? 'compact-table' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div style={customStyle}>
      <Table<T>
        {...rest}
        className={tableClassName}
        bordered={tableVariant === 'bordered'}
        size={tableVariant === 'compact' ? 'small' : 'middle'}
      />
    </div>
  );
}

export default MyTable;
